Librarian.AddRatingWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["onPreviewClicked", "onSubmitClicked"],

    options: {
        id: "AddRatingWindow",
        itemType: null,
        itemData: null,
        width: 500,
        height: 310
    },

    isEditing: true,
    rating: null,

    initialize: function(options) {
        this.setOptions(options);

        if ((this.options.itemData == null) || (this.options.itemType == null))
            return;

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getPluralString("rating", 2);

        if (!Librarian.ratings.override)
            this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/";
        else
            this.options.contentURL = Librarian.path.getLibraryPath();
        this.options.contentURL += "ratings/addratingwindow.html";

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        var suffix = this.options.itemType;

        // If this is a slide, print out the correct slide type ("Slide" vs. "Page") and the slide number
        if (this.options.itemType == "slide") {
            var type = Librarian.Utils.getItemTypeString(this.options.itemData);
            suffix = type.toLowerCase() + " #" + this.options.itemData.slidenumber;
        }

        this.getElement("rateType").set("text", Librarian.Lang.getArgString("rating_rate_type", [suffix]) + ": ");

        var itemEl = this.getElement("ratePreview");
        if (itemEl)
            itemEl.addOnClick(this.onPreviewClicked, this);

        itemEl = this.getElement("rateEdit");
        if (itemEl)
            itemEl.addOnClick(this.onEditClicked, this);

        itemEl = this.getElement("rateCancel");
        if (itemEl)
            itemEl.addOnClick(this.close, this);

        itemEl = this.getElement("rateSubmit");
        if (itemEl)
            itemEl.addOnClick(this.onSubmitClicked, this);

        Librarian.Utils.setElementValue(this.getElement("rateUser"), Librarian.userInfo.DisplayName);
        Librarian.Utils.setElementValue(this.getElement("rateDate"), new Date().format("%B %d, %Y"));

        var starEls = this.contentEl.getElements(".ratings-rate-star");
        for (var i = starEls.length; i--;) {
            starEls[i].onStarMousedOver = this.onStarMousedOver.bind(this);
            starEls[i].addEvent("mouseover", function() {
                this.onStarMousedOver(this);
            });
        }

        var name;
        if (this.options.itemType == "file") {
            if (this.options.itemData.presid > 0)
                name = this.options.itemData.name;
            else
                name = this.options.itemData.groupname || this.options.itemData.filename || this.options.itemData.name;
        }
        else {
            name = this.options.itemData.filename || this.options.itemData.name;

            // If this name ends in the extension of the file, strip it off because this is a slide/page
            var ext = Librarian.Utils.getExtensionFromData(this.options.itemData, true);
            if ((ext.length > 0) && name.endsWith(ext))
                name = name.substring(0, name.length - ext.length - 1);
        }

        if ((typeof name != "undefined") && (name != null))
            Librarian.Utils.setElementValue(this.getElement("rateName"), name);

        itemEl = this.getElement("rateSize");
        if (itemEl) {
            if (itemEl.width)
                this.options.width = itemEl.width.value.toInt();
            if (itemEl.height)
                this.options.height = itemEl.height.value.toInt();

            // Then resize the window
            this.resize({
                width: this.options.width,
                height: this.options.height,
                centered: false
            });
        }
    },

    onClose: function() {
        this.parent();

        if (this.ratingsRequest) {
            this.ratingsRequest.cancel();
            this.ratingsRequest = null;
        }
    },

    onPreviewClicked: function(e) {
        var evt = new Event(e),
            buttonEl = $(evt.target);
        if (!buttonEl || buttonEl.hasClass("disabled"))
            return;

        var comment = Librarian.Utils.getElementValue(this.getElement("rateComment")),
            rating = this.contentEl.getElements(".ratings-rate-star-on").length;

        this.getElement("rateCommentViewText").set("html", Librarian.Utils.textToHtml(comment));
        this.getElement("rateQuality").set("text", Librarian.Lang.getString("rating_quality_" + rating) + ", ");

        this.toggleEdit(false);
    },

    onEditClicked: function(e) {
        var evt = new Event(e),
            buttonEl = $(evt.target);
        if (!buttonEl || buttonEl.hasClass("disabled"))
            return;

        this.toggleEdit(true);
    },

    toggleEdit: function(edit) {
        var itemEl,
            editElements = ["rateType", "rateCommentEditArea"];
        for (var i = editElements.length; i--;) {
            itemEl = this.getElement(editElements[i]);
            if (itemEl)
                itemEl[edit ? "show" : "hide"]();
        }

        var inlineElements = ["rateDate", "rateQuality", "rateEdit", "ratePreviewTitle"];
        for (var i = inlineElements.length; i--;) {
            itemEl = this.getElement(inlineElements[i]);
            if (itemEl)
                itemEl[edit ? "hide" : "show"]("inline-block");
        }

        itemEl = this.getElement("rateCommentViewArea");
        if (itemEl)
            itemEl[edit ? "hide" : "show"]();

        itemEl = this.getElement("rateQuestion");
        if (itemEl)
            itemEl.setStyle("visibility", edit ? "visible" : "hidden");

        itemEl = this.getElement("ratePreview");
        if (itemEl)
            itemEl[edit ? "show" : "hide"]("inline-block");

        this.isEditing = edit;
    },

    onSubmitClicked: function(e) {
        var evt = new Event(e),
            buttonEl = $(evt.target);
        if (!buttonEl || buttonEl.hasClass("disabled"))
            return;

        var comment = (Librarian.Utils.getElementValue(this.getElement("rateComment")) || '').trim(),
            contentType = Librarian.contentType.undefined,
            rating = this.contentEl.getElements(".ratings-rate-star-on").length,
            id = "&cntid=";

        // Build the ID string for files and groups
        if (this.options.itemData.groupid > 0) {
            id += this.options.itemData.groupid + "&cnttype=";
            if (typeof this.options.itemData.eventcount == "number") {

                id += contentType = Librarian.contentType.eventGroup;
            }               
            else
                id += contentType = Librarian.contentType.globalFavorite;
        }
        else if (this.options.itemData.presid > 0)
            id += this.options.itemData.presid + "&cnttype=" + (contentType = Librarian.contentType.myFavorite);
        else if (this.options.itemData.fileid > 0)
            id += this.options.itemData.fileid + "&cnttype=" + (contentType = Librarian.contentType.file);
        else if (this.options.itemData.eventgroupinfo && (this.options.itemData.eventgroupinfo.groupid > 0))
            id += this.options.itemData.eventgroupinfo.groupid + "&cnttype=" + (contentType = Librarian.contentType.eventGroup);

        // If this is a slide
        if (this.options.itemType == "slide") {
            // Use the slide ID if we can
            if (this.options.itemData.slideid > 0)
                id = "&cntid=" + this.options.itemData.slideid + "&cnttype=" + (contentType = Librarian.contentType.slide);
            else if (this.options.itemData.eventid > 0)
                id = "&cntid=" + this.options.itemData.eventid + "&cnttype=" + (contentType = Librarian.contentType.event);
            // Otherwise, use the slide number
            else
                id += "&snum=" + this.options.itemData.slidenumber;
        }

        // Validate comment length
        if (comment.length > 2000) {
            Librarian.Utils.error(Librarian.Lang.getArgString("rating_comment_length", [2000]));
            return;
        }

        // Disable buttons
        Librarian.Utils.setButtonState(this.getElement("ratePreview"), null, true);
        Librarian.Utils.setButtonState(this.getElement("rateEdit"), null, true);
        Librarian.Utils.setButtonState(this.getElement("rateSubmit"), null, true);

        var rating = this.rating = {
            rating: rating,
            cmtxt: comment,
            out: "ujson",
            contentType: contentType
        };

        this.ratingsRequest = new Librarian.Request.JSON({
            url: Librarian.path.getMethodUrl("setrate") + id,
            method: "POST",
            data: rating,
            onSuccess: function(newRating) {
                Librarian.Utils.notification(Librarian.Lang.getString("rating_rate_submitted"));
                this.fireEvent("ratingAdded", newRating);
                if (Librarian.ratings.notify) {
                    this.notify(this.options.itemData, rating);
                } 
                this.close();           
            }.bind(this),
            onFailure: function() {
                Librarian.Utils.error(Librarian.Lang.getString("rating_rate_error"));
                // Re-enable buttons
                Librarian.Utils.setButtonState(this.getElement("ratePreview"), null, false);
                Librarian.Utils.setButtonState(this.getElement("rateEdit"), null, false);
                Librarian.Utils.setButtonState(this.getElement("rateSubmit"), null, false);
            }.bind(this)
        });
        this.ratingsRequest.send();

 
    },

    onStarMousedOver: function(starEl) {
        if (!this.isEditing || !starEl)
            return;

        var value = starEl.attributes["value"].value.toInt(),
            siblingEls = starEl.getSiblings();

        // Set all siblings whose value is less or equal to our own to on, and the others to off
        for (var i = siblingEls.length; i--;) {
            var siblingValue = siblingEls[i].attributes["value"].value.toInt();
            siblingEls[i].toggleClass("ratings-rate-star-on", (siblingValue <= value));
        }

        // Make sure this one is on
        starEl.addClass("ratings-rate-star-on");
    },

    notify: function(content, rating) {
        var self = this;

        this.getAttributes(rating.contentType, function(name) {
            self.getContactInfo(name, function(contact) {
                self.sendNotification(content, rating, contact);
            });
        });
    },

    getAttributes: function(contentType, onSuccess) {
        var itemData = this.options.itemData;
        var params = {
            out: "ujson"
        };

        var method;

        switch (contentType) {
            case Librarian.contentType.globalFavorite:
                method = "getgats";
                params.gid = this.options.itemData.groupid;
                break;
            case Librarian.contentType.slide:
            case Librarian.contentType.file:
                method = "getfats";
                params.fid = this.options.itemData.fileid;
                break;
        }

        if (method) {
            var request = new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl(method) + "&" + Object.toQueryString(params),
                onFailure: Librarian.Utils.onFailure,
                onSuccess: function(json) {
                    if (onSuccess && typeOf(onSuccess) === "function") {
                        var recipient = "";
                        for (var i = 0, len = json.length; i < len; i++) {
                            var meta = json[i];
                            if (meta.Name === Librarian.ratings.notifyMetaData) {
                                recipient = meta.Value;
                                break;
                            }
                        }

                        if (recipient.trim().length > 0) {
                            onSuccess(recipient);
                        }
                    }
                }
            });

            request.send();
        }

    },

    getContactInfo: function(contacts, onSuccess) {
        var emails = contacts.split(";");
        var requestCount = 0;
        var recipients = [];

        var onRequestComplete = function() {
            if (onSuccess && typeOf(onSuccess) === "function") {
                if (recipients.length > 0) {
                    onSuccess(recipients);
                }
            }
        }

        for (var i = 0, len = emails.length; i < len; i++) {
            var params = {
                email: emails[i],
                out: "ujson"
            };

            var request = new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl("getuser") + "&" + Object.toQueryString(params),
                onFailure: function() {
                    requestCount++;

                    if (requestCount === emails.length) {
                        onRequestComplete();
                    }
                },
                onSuccess: function(json) {
                    requestCount++;

                    if (json) {
                        recipients.push(json);
                    }

                    if (requestCount === emails.length) {
                        onRequestComplete();
                    }             
                }
            });

            request.send();
        }



    },

    sendNotification: function(content, rating, contact) {
        var data =
        {
            subject: typeOf(Librarian.ratings.subject) === "function" ? Librarian.ratings.subject(content, rating, Librarian.sessionInfo.UserInfo) : Librarian.ratings.subject,
            messageBody: typeOf(Librarian.ratings.message) === "function" ? Librarian.ratings.message(content, rating, Librarian.sessionInfo.UserInfo) : Librarian.ratings.message,
            recipients: contact,
            sender: Librarian.sessionInfo.UserInfo,
            templateId: 0
        }

        data = JSON.stringify(data);
        if (typeof Base64 != "undefined")
            data = Base64.encode(data);

        var request = new Librarian.Request.JSON({
            url: Librarian.path.getUpdateUrl("addnotifj") + "&in=ujson",
            method: "POST",
            data: data,
            onFailure: Librarian.Utils.onFailure,
            onSuccess: function(json) {
                if (onSuccess && typeOf(onSuccess) === "function") {
                    if (json && json.length > 0) {
                        onSuccess(json[0]);
                    }
                }
            }
        });

        request.send();
    }

})